module.exports = __webpack_public_path__ + "static/media/thaisinai_thumb_even.52ae3c20.webp";